<template>
  <div>
    <b-row class="justify-content-end">
      <b-col md="10" class="my-1"> </b-col>
      <b-col lg="2">
        <b-button v-if="HasPermission(PermissionList.Sales_Create)" variant="success" class="float-right my-1" @click="openAddNoteModal"><feather-icon
            icon="PlusIcon" />Add Note</b-button>
      </b-col>
    </b-row>
    <b-col cols="12" class="d-flex justify-content-end mb-2" style="position: relative; z-index: 1;">
      <b-button variant="outline-danger" size="sm" @click="clearFilters">
        Clear Filters
      </b-button>
    </b-col>

    <div class="d-flex justify-content-center" v-if="loading">
      <b-spinner variant="success" label="Spinning" style="width: 3rem; height: 3rem"></b-spinner>
    </div>

    <b-row>
      <b-col lg="12">
        <b-table striped hover responsive :items="paginatedNotes" :fields=fields>

          <template #head(title)="scope">
            <div class="d-flex flex-column">
              <span>Title</span>
              <b-form-input v-model="filters.title" placeholder="Filter by Title" size="sm" />
            </div>
          </template>

          <template #head(description)="scope">
            <div class="d-flex flex-column">
              <span>Description</span>
              <b-form-input v-model="filters.description" placeholder="Filter by Description" size="sm" />
            </div>
          </template>

          <template #head(salesPerson)="scope">
            <div class="d-flex flex-column">
              <span>Sales Person</span>
              <b-form-input v-model="filters.salesPerson" placeholder="Filter by Sales Person" size="sm" />
            </div>
          </template>

          <template #head(importance)="scope">
            <div class="d-flex flex-column">
              <span>Tag</span>
              <b-form-select v-model="filters.importance" :options="tagOptions" size="sm" />
            </div>
          </template>

          <template #head(dueDate)="scope">
            <div class="d-flex flex-column">
              <span>Due Date</span>
              <DatePicker v-model="filters.dueDateRange" range format="YYYY-MM-DD" placeholder="Select date range"
                @change="applyDateFilters" style="width: 100%;" size="sm" />
            </div>
          </template>

          <template #head(createdOn)="scope">
            <div class="d-flex flex-column">
              <span>Created On</span>
              <DatePicker v-model="filters.createdOnRange" range format="YYYY-MM-DD" placeholder="Select date range"
                @change="applyDateFilters" style="width: 100%;" size="sm" />
            </div>
          </template>


          <template #cell(title)="data">
            <h5>{{ data.item.title || "-N/A-" }}</h5>
          </template>

          <template #cell(description)="data">
            <h5>{{ data.item.description || "no description" }}</h5>
          </template>

          <!-- Sales Person -->
          <template #cell(salesPerson)="data">
            <h5>{{ getSalePersonName(data.item.salesPersonId) }}</h5>
          </template>

          <!-- Created On -->
          <template #cell(createdOn)="data">
            <h6>
              {{ formatDate(data.item.created_On) || "-N/A-" }}
            </h6>
          </template>

          <!-- Importance -->
          <template #cell(importance)="data">
            <b-badge variant="bg-transparent" class="d-flex">
              <feather-icon icon="CircleIcon" :class="['mr-1 text-' + getImportanceVariant(data.item.isImportant)]"
                size="20" />
              <h5>{{ data.item.isImportant ? "Important" : "Mild" }}</h5>
            </b-badge>
          </template>



          <!-- Due Date -->
          <template #cell(dueDate)="data">
            <h6>
              {{ formatDate(data.item.dueDate) || "-N/A-" }}
            </h6>
          </template>
          <!-- Actions -->
          <template #cell(actions)="data">
            <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
              <template #button-content>
                <feather-icon icon="MoreHorizontalIcon" size="16" class="text-body align-middle mr-25" />
              </template>
              <b-dropdown-item @click="openEditModal(data.item)">
                <feather-icon icon="EditIcon" class="mr-50" />
                <span>View / Edit</span>
              </b-dropdown-item>
              <b-dropdown-item @click="confirmDelete(data.item)">
      <feather-icon icon="Trash2Icon" class="mr-50 text-danger" />
      <span class="text-danger">Delete</span>
    </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center"
          class="my-3"></b-pagination>
      </b-col>
    </b-row>


    <!--- Add Note Modal -->
    <b-modal id="addNoteModal" title="Add Note" v-model="showAddNoteModal" centered @ok="handleAddNote" size="lg">
      <b-row>
        <b-col md="6">
          <b-form-group label="Note Title" label-for="noteTitleInput" :state="titleValidation"
            :invalid-feedback="titleError">
            <b-form-input id="noteTitleInput" required v-model="title" @change="validateTitle"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Tag" label-for="tagInput">
            <v-select :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="optionTags" label="title"
              v-model="selectedTag" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Sales Person" label-for="salesPersonInput" :state="salespersonValidation"
            :invalid-feedback="salespersonError">
            <b-form-select id="salesPersonId" v-model="salesPersonId" :options="optionsSalesPerson" required
              @input="validateSalesperson" />
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group label="Due Date" label-for="dueDateInput" :state="dueDateValidation"
            :invalid-feedback="dueDateError">
            <b-form-datepicker id="example-purchase" class="mb" v-model="dueDate" required @input="validateDueDate" />
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="Description" label-for="editDescription">
            <b-form-textarea id="editDescription" v-model="description"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <!-- <template #modal-footer>
        <b-button @click="handleAddNote">
          <b-spinner v-if="loadingAdd" type="grow" small></b-spinner>
          <span v-if="!loading">Add Note</span>
        </b-button>
      </template> -->
      <template #modal-footer>
        <b-button 
          @click="handleAddNote"
          :disabled="loadingAdd"
        >
          <b-spinner v-if="loadingAdd" type="grow" small></b-spinner>
          <span v-if="!loadingAdd">Add Note</span>
        </b-button>
      </template>
    </b-modal>
    <!-- View Note Modal -->
    <b-modal id="viewModal" title="View Note" v-model="showViewModal" centered>
      <p><strong>Note Title: </strong>{{ selectedNote.title }}</p>

      <p>
        <strong>Sales Person: </strong>{{ getSalePersonName(selectedNote.salesPersonId) }}
      </p>
      <p><strong>Description: </strong>{{ selectedNote.description }}</p>
      <p><strong>Date: </strong>{{ formatDate(selectedNote.dueDate) }}</p>
      <p>
        <strong>Status: </strong><b-badge variant="bg-transparent" class="d-flex">
          <feather-icon icon="CircleIcon" :class="[
            'mr-1 text-' + getImportanceVariant(selectedNote.isImportant),
          ]" size="20" />
          <h5>{{ selectedNote.isImportant ? "Important" : "Mild" }}</h5>
        </b-badge>
      </p>
      <template #modal-footer></template>
    </b-modal>
    <!-- Edit Note Modal -->
    <b-modal id="editNoteModal" title="Add Note" v-model="showEditNoteModal" centered size="lg">
      <b-row>
        <b-col md="6">
          <b-form-group label="Note Title" label-for="noteTitleInput" :state="editTitleValidation"
            :invalid-feedback="editTitleError">
            <b-form-input id="noteTitleInput" v-model="selectedNote.title" required :disabled="!isEdit"
              @change="validateEditTitle"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Tag" label-for="tagInput">
            <v-select :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="optionTags" label="title" :disabled="!isEdit"
              v-model="selectedTag" :clearable="false" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Sales Person" label-for="salesPersonInput">
            <b-form-select v-model="selectedNote.salesPersonId" :disabled="!isEdit" :options="optionsSalesPerson" />
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group label="Due Date" label-for="dueDateInput" :state="editDueDateValidation"
            :invalid-feedback="editDueDateError">
            <b-form-datepicker id="example-purchase" class="mb-1" v-model="selectedNote.dueDate" required :disabled="!isEdit"
              @blur="validateEditDueDate"></b-form-datepicker>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group label="Description" label-for="editDescription">
            <b-form-textarea id="editDescription" v-model="selectedNote.description" :disabled="!isEdit"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <template #modal-footer>

      <b-button v-if="isEdit" @click="handleEditNote">
        <b-spinner v-if="loading" type="grow" small></b-spinner>
        <span v-if="!loading">Update Note</span>
      </b-button>
      

      <b-button v-else disabled style="visibility: hidden;">
        <span>&nbsp;</span>
      </b-button>
    </template>

    </b-modal>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import {
  BPagination,
  BListGroup,
  BListGroupItem,
  BFormDatepicker,
  BCard,
  BRow,
  BCol,
  BButton,
  BCardTitle,
  BCardSubTitle,
  BBadge,
  BDropdown,
  BSpinner,
  BDropdownItem,
  BModal,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BInputGroup,
  BInputGroupAppend,
  BForm,
  BFormSelect,
  BTable,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import vSelect from "vue-select";
import api from "@/api/api-v2-config";
import { mapActions, mapGetters } from "vuex";
import { fnSortingDropdown, customLoader } from "@/libs/customFn";
import { PermissionList } from '@/libs/defaultList';
import { HasPermission } from '@/@core/utils/validations/permissionCheck';
export default {
  components: {
    BPagination,
    BListGroup,
    BListGroupItem,
    BFormDatepicker,
    BSpinner,
    BCard,
    BRow,
    BCol,
    BButton,
    BCardTitle,
    BCardSubTitle,
    BBadge,
    BDropdown,
    BDropdownItem,
    BModal,
    BFormGroup,
    BFormInput,
    vSelect,
    flatPickr,
    BFormTextarea,
    BInputGroup,
    BInputGroupAppend,
    BForm,
    BFormSelect,
    BTable,
    DatePicker
  },
  data() {
    return {
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 0,
      currentPage: 1,
      sortBy: null,
      sortDesc: false,
      filterOn: [],
      sortDirection: "asc",
      isEdit: false,
      titleValidation: null,
      salespersonValidation: null,
      descriptionValidation: null,
      dueDateValidation: null,
      titleError: "",
      descriptionError: "",
      dueDateError: "",
      editTitleValidation: null,
      editDescriptionValidation: null,
      editDueDateValidation: null,
      editTitleError: "",
      editDescriptionError: "",
      editDueDateError: "",
      id: this.$route.params.id,
      loadingAdd: false,
      title: "",
      description: "",
      selectedStatus: "",
      selectedTag: "",
      salesPersonId: null,
      showAddNoteModal: false,
      showViewModal: false,
      showEditNoteModal: false,
      selectedNote: {},
      dueDate: null,
      optionsSalesPerson: [],
      isImportant: false,
      notes: [],
      fields: [
        { key: "title", label: "Title" , sortable: true},
        { key: "description", label: "Description" , sortable: true},
        { key: "salesPerson", label: "Sales Person" , sortable: true},
        { key: "importance", label: "Tag" , sortable: true},
        { key: "dueDate", label: "Due Date" , sortable: true},
        { key: "createdOn", label: "Created On" , sortable: true},
          { key: "actions", label: "Actions" }, // New actions column
      ],
      filters: {
        title: "",
        description: "",
        salesPerson: "",
        dueDateRange: [null, null],
        importance: null,
        createdOnRange: [null, null],
      },
      tagOptions: [
        { value: null, text: "All" },
        { value: true, text: "Important" },
        { value: false, text: "Mild" },
      ],
      optionTags: [
        { title: "Mild", value: false },
        { title: "Important", value: true },
      ],
      salespersonError: null,
      loading: true,
    };
  },

  computed: {
    filteredNotes() {
      // Apply filters to the data
      return this.notes
        .filter((note) =>
          this.filters.title
            ? note.title.toLowerCase().includes(this.filters.title.toLowerCase())
            : true
        )
        .filter((note) =>
          this.filters.description
            ? note.description
              .toLowerCase()
              .includes(this.filters.description.toLowerCase())
            : true
        )
        .filter((note) =>
          this.filters.salesPerson
            ? this.getSalePersonName(note.salesPersonId)
              .toLowerCase()
              .includes(this.filters.salesPerson.toLowerCase())
            : true
        )
        .filter((note) =>
          this.filters.importance !== null
            ? note.isImportant === this.filters.importance
            : true
        )
        .filter((note) =>
          this.filters.dueDateRange[0] && this.filters.dueDateRange[1]
            ? new Date(note.dueDate) >= new Date(this.filters.dueDateRange[0]) &&
            new Date(note.dueDate) <= new Date(this.filters.dueDateRange[1])
            : true
        )
        .filter((note) =>
          this.filters.createdOnRange[0] && this.filters.createdOnRange[1]
            ? new Date(note.created_On) >= new Date(this.filters.createdOnRange[0]) &&
            new Date(note.created_On) <= new Date(this.filters.createdOnRange[1])
            : true
        );
    },
    paginatedNotes() {
      // Apply pagination to the filtered data
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      this.totalRows = this.filteredNotes.length; // Update total rows for pagination
      return this.filteredNotes.slice(start, end);
    },
    ...mapGetters("salesPersonModule", {
      SalesPersonList: "salesperson",
      loadingSalesPerson: "loading",
    }),
    sortedNotes() {
      if (!this.notes || this.notes.length === 0) return this.notes;

      return this.notes
        .map((note) => {
          const salesPersonName = this.getSalePersonName(note.salesPersonId);
          return {
            ...note,
            salesPerson: salesPersonName || "-N/A-",
          };
        })
        .sort((a, b) => {
          const dateA = new Date(a.created_On);
          const dateB = new Date(b.created_On);
          return dateB - dateA; // Sort in descending order
        });
    },
  },
  methods: {
    ...mapActions("salesPersonModule", ["getSalesPersonListAction"]),
    formatDate(isoString) {
      const date = new Date(isoString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-indexed in JavaScript
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
    clearFilters() {
      // Reset all filters to their default values
      this.filters = {
        title: "",
        description: "",
        salesPerson: "",
        dueDateRange: [null, null],
        importance: null,
        createdOnRange: [null, null],
      };
      // Reset pagination to the first page
      this.currentPage = 1;
    },
    applyDateFilters() {
      this.currentPage = 1; // Reset to first page when filters change
    },
    handleAddNote() {
      if (this.loadingAdd) return; // Prevent double submission
      this.addNotes();
    },
    // handleAddNote() {
    //   this.addNotes();
    // },
    handleEditNote() {
      this.validateEditTitle();
      this.validateEditDueDate();

      if (this.editTitleValidation && this.editDueDateValidation) {
        this.editNote();
      }
    },

    validateEditTitle() {
      if (!this.selectedNote.title) {
        this.editTitleValidation = false;
        this.editTitleError = "Title is required";
      } else {
        this.editTitleValidation = true;
        this.editTitleError = "";
      }
    },

    validateEditDescription() {
      if (!this.selectedNote.description) {
        this.editDescriptionValidation = false;
        this.editDescriptionError = "Description is required";
      } else {
        this.editDescriptionValidation = true;
        this.editDescriptionError = "";
      }
    },

    validateEditDueDate() {
      if (!this.selectedNote.dueDate) {
        this.editDueDateValidation = false;
        this.editDueDateError = "Due date is required";
      } else {
        this.editDueDateValidation = true;
        this.editDueDateError = "";
      }
    },
    validateTitle() {
      if (!this.title) {
        this.titleValidation = false;
        this.titleError = "Title is required";
      } else {
        this.titleValidation = true;
        this.titleError = "";
      }
    },
    validateDescription() {
      if (!this.description) {
        this.descriptionValidation = false;
        this.descriptionError = "Description is required";
      } else {
        this.descriptionValidation = true;
        this.descriptionError = "";
      }
    },
    validateDueDate() {
      if (!this.dueDate) {
        this.dueDateValidation = false;
        this.dueDateError = "Due date is required";
      } else {
        this.dueDateValidation = true;
        this.dueDateError = "";
      }
    },
    validateSalesperson() {
      if (!this.salesPersonId) {
        this.salespersonValidation = false;
        this.salespersonError = "Salesperson is required";
      } else {
        this.salespersonValidation = true;
        this.salespersonError = "";
      }
    },
    editNote() {
      this.loading = true;
      const payload = {
        id: this.selectedNote.id,
        title: this.selectedNote.title,
        salesPersonId: this.selectedNote.salesPersonId,
        dueDate: this.selectedNote.dueDate,
        tag: this.selectedTag.value ? "Important" : "Mild",
        description: this.selectedNote.description,
        isImportant: this.selectedTag.value,
        isActive: this.selectedNote.isActive,
        leadClientId: this.id,
      };

      api
        .put(`/notes`, payload)
        .then((response) => {
          this.loading = false;
          this.getNotes(this.id);
          this.$swal({
            icon: "success",
            title: "Success!",
            text: "Note updated successfully.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          this.showEditNoteModal = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$swal({
            icon: "error",
            title: "Error!",
            text: "Failed to update note.",
            customClass: {
              confirmButton: "btn btn-warning",
            },
          });
        });
    },

    getImportanceVariant(isImportant) {
      return isImportant ? "danger" : "info";
    },

    getSalePersonName(id) {
      const salesPerson = this.SalesPersonList.find((person) => person.id === id);
      return salesPerson ? `${salesPerson.firstName} ${salesPerson.lastName}` : "-N/A-";
    },
    getNotes(id) {
      this.loading = true;
      api
        .get(`/notes/byleadclientid/${id}`)
        .then((response) => {
          this.notes = response.data.result;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });
    },

    async addNotes() {
      if (this.loadingAdd) return;
      this.loadingAdd = true;
      
      this.validateTitle();
      this.validateDueDate();
      this.validateSalesperson();
      
      if (
        this.titleValidation &&
        this.dueDateValidation &&
        this.salespersonValidation
      ) {
        let payload = {
          title: this.title,
          salesPersonId: this.salesPersonId,
          dueDate: this.dueDate,
          tag: this.isImportant ? "Important" : "Mild",
          description: this.description,
          isImportant: this.selectedTag.value,
          isActive: true,
          leadClientId: this.id,
        };
        
        try {
          await api.post("/notes", payload);
          await this.getNotes(this.id);
          
          this.$swal({
            icon: "success",
            title: "Success!",
            text: "Note added successfully.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });

          // Reset form
          this.title = "";
          this.salesPersonId = "";
          this.dueDate = null;
          this.description = "";
          this.selectedTag = "";
          this.isImportant = false;
          this.showAddNoteModal = false;
        } catch (error) {
          this.$swal({
            icon: "error",
            title: "Error!",
            text: "Failed to add note.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        } finally {
          this.loadingAdd = false;
        }
      } else {
        this.loadingAdd = false;
      }
    },

    // addNotes() {
    //   this.loadingAdd = true;
    //   this.validateTitle();
    //   this.validateDueDate();
    //   this.validateSalesperson();
    //   if (
    //     this.titleValidation &&
    //     this.dueDateValidation &&
    //     this.salespersonValidation
    //   ) {
    //     let payload = {
    //       title: this.title,
    //       salesPersonId: this.salesPersonId,
    //       dueDate: this.dueDate,
    //       tag: this.isImportant ? "Important" : "Mild",
    //       description: this.description,
    //       isImportant: this.selectedTag.value,
    //       isActive: true,
    //       leadClientId: this.id,
    //     };
    //     api
    //       .post("/tasks", payload)
    //       .then((response) => {
    //         this.getNotes(this.id);
    //         this.$swal({
    //           icon: "success",
    //           title: "Success!",
    //           text: "Note added successfully.",
    //           customClass: {
    //             confirmButton: "btn btn-success",
    //           },
    //         });

    //         this.title = "";
    //         this.salesPersonId = "";
    //         this.dueDate = null;
    //         this.description = "";
    //         this.selectedTag = "";
    //         this.isImportant = false;
    //         this.showAddNoteModal = false;
    //       })
    //       .catch((error) => {
    //         this.loadingAdd = false;
    //         this.$swal({
    //           icon: "error",
    //           title: "Error!",
    //           text: "Failed to add note.",
    //           customClass: {
    //             confirmButton: "btn btn-success",
    //           },
    //         });
    //       });
    //   }
    // },
    openAddNoteModal() {
      this.showAddNoteModal = true;
    },
    openViewModal(note) {
      this.selectedNote = note;
      this.showViewModal = true;
    },
    openEditModal(note) {
      this.selectedNote = note;
      this.selectedTag = this.optionTags.find(
        (tag) => tag.value === note.isImportant
      );
      this.showEditNoteModal = true;
    },
    getTypeVariant() {
      return this.isImportant ? "danger" : "info";
    },

    getTagVariant(tag) {
      switch (tag) {
        case "Important":
          return "danger";
        case "Mild":
          return "info";
        default:
          return "secondary";
      }
    },

    deleteNotes(taskId) {
  this.loading = true;
  
  api.delete(`/notes/${taskId}`)
    .then(() => {
      // Remove the note from the UI without reloading all notes
      this.notes = this.notes.filter(note => note.id !== taskId);

      this.$swal({
        icon: "success",
        title: "Deleted!",
        text: "The note has been deleted.",
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    })
    .catch((error) => {
      console.error("Delete error:", error);
      this.$swal({
        icon: "error",
        title: "Error!",
        text: "Failed to delete note.",
        customClass: {
          confirmButton: "btn btn-warning",
        },
      });
    })
    .finally(() => {
      this.loading = false;
    });
},


    // deleting a note
    confirmDelete(note) {
  this.$swal({
    title: "Delete Note?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete it!",
    customClass: {
      confirmButton: "btn btn-primary",
      cancelButton: "btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  }).then((result) => {
    if (result.isConfirmed) {
      this.deleteNotes(note.id);
    }
  });
},

  },

  async mounted() {
    this.isEdit = HasPermission(PermissionList.Sales_Update);
    this.getNotes(this.id);

    await this.getSalesPersonListAction().then(() => {
      this.SalesPersonList.map((v, i) =>
        this.optionsSalesPerson.push({
          value: v.id,
          text: `${v.firstName}` + " " + `${v.lastName}`,
        })
      );
    });
    this.optionsSalesPerson = fnSortingDropdown(this.optionsSalesPerson);
  },
  setup(props) {
    return {
      PermissionList,
      HasPermission
    }
  },
  props: {
    heading: {
      type: String,
      default: "To Do",
    },
  },
};
</script>
<style lang="scss" scoped>
.is-done {
  color: #666;
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
